/**
 * Ayuda — Administración → Ventas
 */

import { ADM_SAL_ENTITIES_ITEM } from './adm-sal-entities.js'
import { ADM_SAL_ENTITY_GROUPS_ITEM } from './adm-sal-entity-groups.js'
import { ADM_SAL_PRESUPUESTOS_ITEM } from './adm-sal-presupuestos.js'
import { ADM_SAL_REMITS_ITEM } from './adm-sal-remits.js'
import { ADM_SAL_INVOICES_ITEM } from './adm-sal-invoices.js'
import { ADM_SAL_ACCOUNTS_ITEM } from './adm-sal-accounts.js'

/** @type {import('../help-index.js').HelpScreen} */
export const ADM_SAL_HELP = {
  screenId: 'adm-sal',
  label: 'Ventas',
  navPath: 'Administración → Ventas',
  keywords: [
    'venta', 'ventas', 'factura venta', 'remito venta', 'cliente', 'clientes',
    'presupuesto', 'presupuestos', 'remito', 'remitos', 'factura', 'facturas',
    'cuenta corriente', 'pendiente de cobro', 'entrega', 'cotización', 'validez', 'condición de pago',
    'cuenta corriente', 'grupo de clientes', 'categoría', 'razón social', 'cuit',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Cuando entrás a Ventas, a la izquierda ves un menú con las opciones disponibles: Clientes, Presupuestos, Remitos, Facturas y más. Elegí una opción para trabajar en el área principal. En esta ayuda, tocá cada tema para ver cómo usarlo paso a paso.',
  sidebarItems: [
    ADM_SAL_ENTITIES_ITEM,
    ADM_SAL_ENTITY_GROUPS_ITEM,
    ADM_SAL_PRESUPUESTOS_ITEM,
    ADM_SAL_REMITS_ITEM,
    ADM_SAL_INVOICES_ITEM,
    ADM_SAL_ACCOUNTS_ITEM,
  ],
}
